import { useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import "./AddPortCode.scss";

import { AbsCheckBox, Label } from "abs-ui-components";
import { Input } from "abs-ui-components";

import AutocompleteDropdown from "../../../common/autocompleteDropdown/AutocompleteDropdown";
import { emitToasterMsg } from "../../../services/toasterUtility";
import {
	PostPortCode,
	UpdatePortCode,
	getAllCountries,
} from "../../../services/PortCodeService";

const AddPortCode = ({ onClose, editPortCode, type, onRefetchPortCodes }) => {
	const [isEuPort, setIsEuPort] = useState(editPortCode?.isEuport || false);
	const [isUkPort, setIsUkPort] = useState(editPortCode?.isUkport || false);
	const [isSmallIsLand, setIsSmallIsland] = useState(
		editPortCode?.isSmallIsLand || false
	);
	const [isOmr, setisOmr] = useState(editPortCode?.isOmr || false);
	const [isTransnational, setIsTransnational] = useState(
		editPortCode?.isTransnational || false
	);

	const [isTransShipment, setIsTransShipment] = useState(
		editPortCode?.isTransShipment || false
	);
	const [isFuelEuPort, setIsFuelEuPort] = useState(
		editPortCode?.isFeuPort || false
	);
	const [isFuelTransShipment, setIsFuelTransShipment] = useState(
		editPortCode?.isFeuTransshipment || false
	);
	const [isFuelSmallIsland, setIsFuelSmallIsland] = useState(
		editPortCode?.isFeuSmallIsland || false
	);
	const [isFuelOmr21, setIsFuelOmr21] = useState(
		editPortCode?.isFeuOmr21 || false
	);
	const [isFuelOmr24, setIsFuelOmr24] = useState(
		editPortCode?.isFeuOmr24 || false
	);
	const [isFuelTransnational25, setIsFuelTransnational25] = useState(
		editPortCode?.isFeuTransnational25 || false
	);
	const [isFuelTransnational26, setIsFuelTransnational26] = useState(
		editPortCode?.isFeuTransnational26 || false
	);
	const [isTerritory, setIsTerritory] = useState(
		!!(editPortCode?.isTerritory ?? editPortCode?.territory)
	);
	const {
		control,
		handleSubmit,
		formState: { errors },
		watch,
		getValues,
		setValue,
	} = useForm();

	const addPortCodeForm = getValues("addPortCodeForm");

	useEffect(() => {
		watch(addPortCodeForm);
		if (editPortCode && editPortCode.isEuPort) {
			setIsEuPort(true);
		}
		if (editPortCode && editPortCode.isFeuPort) {
			setIsFuelEuPort(true);
		}
		if (editPortCode && editPortCode.isUkPort) {
			setIsUkPort(true);
		}
		if (editPortCode && editPortCode.isTransShipment) {
			setIsTransShipment(true);
		}
		if (editPortCode && editPortCode.isSmallIsLand) {
			setIsSmallIsland(true);
		}
		if (editPortCode && editPortCode.isOmr) {
			setisOmr(true);
		}
		if (editPortCode && editPortCode.isTransnational) {
			setIsTransnational(true);
		}

		if (editPortCode && editPortCode.isFeuTransshipment) {
			setIsFuelTransShipment(true);
		}
		if (editPortCode && editPortCode.isFeuSmallIsland) {
			setIsFuelSmallIsland(true);
		}
		if (editPortCode && editPortCode.isFeuOmr21) {
			setIsFuelOmr21(true);
		}
		if (editPortCode && editPortCode.isFeuOmr24) {
			setIsFuelOmr24(true);
		}
		if (editPortCode && editPortCode.isFeuTransnational25) {
			setIsFuelTransnational25(true);
		}
		if (editPortCode && editPortCode.isFeuTransnational26) {
			setIsFuelTransnational26(true);
		}
		if (editPortCode && (editPortCode.isTerritory || editPortCode.territory)) {
			setIsTerritory(true);
		}

		if (editPortCode) {
			const fePort = !!editPortCode.isFeuPort;
			const feTrans = !!editPortCode.isFeuTransshipment;
			const feSmall = !!editPortCode.isFeuSmallIsland;
			const feOmr = !!editPortCode.isFeuOmr;
			const feTransNat25 = !!editPortCode.isFeuTransnational25;
			const feTransNat26 = !!editPortCode.isFeuTransnational26;

		}
	}, [editPortCode, watch]);

	//  handles checkbox action
	const handleEuPort = (e) => {
    const checked = e.target.checked;
    setValue("addPortCodeForm.isEuPort", checked);
    setIsEuPort(checked);
	};
const handleFuelEuPort = (e) => {
    const checked = e.target.checked;
    setValue("addPortCodeForm.isFuelEuPort", checked);
    setIsFuelEuPort(checked);
};

	const handleUkPort = (e) => {
    const checked = e.target.checked;
    setValue("addPortCodeForm.isUkPort", checked);
    setIsUkPort(checked);
};

	const handleFuelIsTransShipment = (e) => {
		setValue("addPortCodeForm.isFuelTransShipment", e.target.checked);
		setIsFuelTransShipment(e.target.checked);
	};

	const handleFuelIsSmallIsLand = (e) => {
		setValue("addPortCodeForm.isFuelSmallIsland", e.target.checked);
		setIsFuelSmallIsland(e.target.checked);
	};

	const handleFuelIsOmr21 = (e) => {
		setValue("addPortCodeForm.isFuelOmr21", e.target.checked);
		setIsFuelOmr21(e.target.checked);
	};

	const handleFuelIsOmr24 = (e) => {
		setValue("addPortCodeForm.isFuelOmr24", e.target.checked);
		setIsFuelOmr24(e.target.checked);
	};

	const handleFuelIsTransnational25 = (e) => {
		setValue("addPortCodeForm.isFuelTransnational25", e.target.checked);
		setIsFuelTransnational25(e.target.checked);
	};

	const handleFuelIsTransnational26 = (e) => {
		setValue("addPortCodeForm.isFuelTransnational26", e.target.checked);
		setIsFuelTransnational26(e.target.checked);
	};

	const handleIsTransShipment = (e) => {
		setValue("addPortCodeForm.isTransShipment", e.target.checked);
		setIsTransShipment(e.target.checked);
	};

	const handleIsSmallIsLand = (e) => {
		setValue("addPortCodeForm.isSmallIsland", e.target.checked);
		setIsSmallIsland(e.target.checked);
	};

	const handleisOmr = (e) => {
		setValue("addPortCodeForm.isOmr", e.target.checked);
		setisOmr(e.target.checked);
	};

	const handleIsTransnational = (e) => {
		setValue("addPortCodeForm.isTransnational", e.target.checked);
		setIsTransnational(e.target.checked);
	};

	const handleTerritoryChange = (e) => {
		const checked = e.target.checked;
		setValue("addPortCodeForm.isTerritory", checked);
		if (!checked) {
			setValue("addPortCodeForm.territory", "");
		}
		setIsTerritory(checked);
	};

	const handleCountries = (loadPortCodeFormData) => {
				if (
			loadPortCodeFormData &&
			loadPortCodeFormData.countryMstId &&
			loadPortCodeFormData.countryMstId.value
		) {
			loadPortCodeFormData.countryMstId =
				+loadPortCodeFormData?.countryMstId?.value;
		}

		loadPortCodeFormData.isFeuPort = !!loadPortCodeFormData.isFuelEuPort;
		loadPortCodeFormData.isFeuTransshipment = !!loadPortCodeFormData.isFuelTransShipment;
		loadPortCodeFormData.isFeuSmallIsland = !!loadPortCodeFormData.isFuelSmallIsland;
		loadPortCodeFormData.isFeuOmr21 = !!loadPortCodeFormData.isFuelOmr21;
		loadPortCodeFormData.isFeuOmr24 = !!loadPortCodeFormData.isFuelOmr24;
		loadPortCodeFormData.isFeuTransnational25 = !!loadPortCodeFormData.isFuelTransnational25;
		loadPortCodeFormData.isFeuTransnational26 = !!loadPortCodeFormData.isFuelTransnational26;

		return loadPortCodeFormData;
	};

	const constructPortCodePayload = (formData) => {
		let payload = {
			"portCode": formData["portCode"],
			"portName": formData["portName"],
			"countryMstId": formData["countryMstId"],
			"isActive": formData["isActive"] ? "Y" : "N",
			portCodeMetadata: {
				"isDcsPort": formData["isDcsPort"]? "Y" : "N",
				"isFeuPort": formData["isFuelEuPort"]? "Y" : "N",
				"isEuPort": formData["isEuPort"]? "Y" : "N",
				"isUkPort": formData["isUkPort"]? "Y" : "N",
				"isTerritory": formData["isTerritory"] || isTerritory? "Y" : "N",
				"thetis": formData["thetis"] || "",
			},
		};

		
			payload.portCodeMetadata['isTransShipment'] = formData["isTransShipment"] ? "Y" : "N";
			payload.portCodeMetadata['isOmr'] = formData["isOmr"] ? "Y" : "N";
			payload.portCodeMetadata['isSmallIsland'] = formData["isSmallIsland"] ? "Y" : "N";
			payload.portCodeMetadata['isTransnational'] = formData["isTransnational"] ? "Y" : "N";
			payload.portCodeMetadata['territory'] = formData["territory"] || "";
		
		if (formData["isTerritory"] === true || isTerritory) {
			payload.portCodeMetadata['territory'] = formData["territory"];
		} 
		
			payload.portCodeMetadata['isFeuTransshipment'] = formData["isFuelTransShipment"] ? "Y" : "N";
			payload.portCodeMetadata['isFeuOmr21'] = formData["isFuelOmr21"] ? "Y" : "N";
			payload.portCodeMetadata['isFeuOmr24'] = formData["isFuelOmr24"] ? "Y" : "N";
			payload.portCodeMetadata['isFeuTransnational25'] = formData["isFuelTransnational25"] ? "Y" : "N";
			payload.portCodeMetadata['isFeuTransnational26'] = formData["isFuelTransnational26"] ? "Y" : "N";
			payload.portCodeMetadata['isFeuSmallIsland'] = formData["isFuelSmallIsland"] ? "Y" : "N";
		
		return payload;
	};

	const handlePortCodeFormSubmit = async () => {
		addPortCodeForm["isActive"] = true;
		if (addPortCodeForm && addPortCodeForm["isDcsPort"] == undefined) {
			addPortCodeForm["isDcsPort"] = false;
		}
		if (addPortCodeForm && !addPortCodeForm["isTerritory"]) {
			addPortCodeForm["isTerritory"] = false;
			addPortCodeForm["territory"] = "";
		}
		const payload = handleCountries(addPortCodeForm);
		const finalPayload = constructPortCodePayload(payload);

		try {
			//for create port code
			if (type == "Add") {
				let toasterMessage = "Added Successfully";
				let response = await PostPortCode(finalPayload);

				if (response.isSuccess) {
					emitToasterMsg("success", "Port Code", toasterMessage);
					onRefetchPortCodes();
					onClose();
				} else {
					emitToasterMsg(
						"error",
						"Port Code",
						response.message
							? response.message
							: "Failed to Update Port Code"
					);
				}
				// for updating port code
			} else {
				let queryParam = `?portCodeMstId=${editPortCode.portCodeMstId}`;
				let response = await UpdatePortCode(finalPayload, queryParam);
				let toasterMessage = "Updated Successfully";
				if (response.isSuccess) {
					emitToasterMsg("success", "Port Code", toasterMessage);
					onRefetchPortCodes();
					onClose();
				} else {
					emitToasterMsg(
						"error",
						"Port Code",
						response.message
							? response.message
							: "Failed to Update Port Code"
					);
				}
			}
		} catch (error) {
			console.error(error?.message);
		}
	};

	const handleCancel = () => {
		onClose();
	};

	// loading countries options in dropdown
	const countryLoadOptions = async (searchInputValue = "") => {
		try {
			const payLoad = {
				searchKey: searchInputValue,
			};
			const response = await getAllCountries(payLoad);
			const formattedCountryOptions = response?.map((item) => {
				return {
					label: `${item?.CountryName}`,
					value: `${item?.CountryMstId}`,
					countryCode: `${item?.CountryCode}`,
				};
			});
			return formattedCountryOptions;
		} catch (error) {
			emitToasterMsg("error", "Error", error.message);
		}
	};

	return (
		<>
			<form
				onSubmit={handleSubmit(handlePortCodeFormSubmit)}
				className="add-portcode-form"
				id="add-portcode-form-id"
			>
				<MDBRow>
					<MDBCol md="2" className="input-div-height">
						<Controller
							name="addPortCodeForm.portCode"
							control={control}
							rules={{
								required: "Port Code is required",
								validate: (value) =>
									value.length === 5 ||
									"Port Code should be 5 characters only",
							}}
							defaultValue={editPortCode?.portCode?.trim() || ""}
							render={({ field }) => (
								<>
									<div>
										<Input
											required
											id="port-code"
											onChange={(e) => {
												field.onChange(e.toUpperCase());
											}}
											className="inputHeight"
											type="text"
											label="Port Code"
											bold
											minLength={5}
											maxLength={5}
											value={field.value}
											autoFocus={false}
										/>
									</div>
									<div className="mt-1">
										{errors?.addPortCodeForm?.portCode && (
											<div className="error">
												{
													errors?.addPortCodeForm
														?.portCode?.message
												}
											</div>
										)}
									</div>
								</>
							)}
						/>
					</MDBCol>

					<MDBCol md="5" className="input-div-height">
						<Controller
							name="addPortCodeForm.portName"
							control={control}
							rules={{
								required: "Port Name is required",
								maxLength: {
									value: 100,
									message: "Max length is 100 characters",
								},
							}}
							defaultValue={editPortCode?.portName?.trim() || ""}
							render={({ field }) => (
								<Input
									id="port-name"
									{...field}
									required
									onChange={(e) => {
										field.onChange(e);
									}}
									className="inputHeight"
									type="text"
									label="Port Name"
									bold
									value={field.value}
									autoFocus={false}
								/>
							)}
						/>
						<div className="mt-1">
							{errors?.addPortCodeForm?.portName && (
								<div className="error">
									{errors?.addPortCodeForm?.portName?.message}
								</div>
							)}
						</div>
					</MDBCol>
					<MDBCol md="5" className="input-div-height">
						<Label bold required name="Country" className="mb-2" />
						<Controller
							label="Country"
							name="addPortCodeForm.countryMstId"
							rules={{
								required: "Country is required",
							}}
							control={control}
							defaultValue={
								editPortCode
									? {
											label: editPortCode?.country
												?.countryName,
											value: editPortCode?.country
												?.countryMstId,
											countryCode:
												editPortCode?.country
													?.countryCode,
									  }
									: ""
							}
							render={({ field }) => {
								return (
									<AutocompleteDropdown
										className="inputHeight"
										id="country-portcode"
										{...field}
										isClearable
										loadOptions={countryLoadOptions}
										placeholder="Search Country"
										getOptionLabel={(option) =>
											`${option?.label} (${option?.countryCode})`
										}
										defaultOptions={
											editPortCode
												? [
														{
															label: editPortCode?.countryName,
															value: editPortCode?.countryMstId,
															countryCode:
																editPortCode?.countryCode,
														},
												  ]
												: ""
										}
										autoFocus={false}
										customStyles={{
											menuList: (provided) => ({
												...provided,
												maxHeight: 150,
											}),
										}}
									/>
								);
							}}
						/>
						{errors?.addPortCodeForm?.countryMstId && (
							<div className="error">
								{errors?.addPortCodeForm?.countryMstId?.message}
							</div>
						)}
					</MDBCol>
				</MDBRow>

				<MDBRow className="checkbox-row pt-4">
					<MDBCol md="3" className="pl-0">
						<Controller
							control={control}
							name="addPortCodeForm.isEuPort"
							defaultValue={editPortCode?.isEuPort || false}
							render={({ field }) => (
								<AbsCheckBox
									handleChange={(e) => {
										field.onChange(e.target.checked);
										handleEuPort(e);
									}}
									label="EU Port"
									id="eucountry-portcode"
									onChange={(e) => {
										field.onChange(e);
									}}
									{...field}
									checked={field.value}
									value={field.value}
								/>
							)}
						/>
						
							<div className="sub-checkbox-list">
								<Controller
									control={control}
									name="addPortCodeForm.isTransShipment"
									defaultValue={editPortCode?.isTransShipment || false}
									render={({ field }) => (
										<AbsCheckBox
											handleChange={(e) => {
												field.onChange(e.target.checked);
												handleIsTransShipment(e);
											}}
											label={<span className="sm">EU Transhipment</span>}
											id="IsTransShipment-portcode"
											onChange={(e) => {
												field.onChange(e);
											}}
											{...field}
											checked={field.value}
											value={field.value}
										/>
									)}
								/>
								<Controller
									control={control}
									name="addPortCodeForm.isSmallIsland"
									defaultValue={editPortCode?.isSmallIsland || false}
									render={({ field }) => (
										<AbsCheckBox
											handleChange={(e) => {
												field.onChange(e.target.checked);
												handleIsSmallIsLand(e);
											}}
											label={<span className="sm">EU Small Island</span>}
											id="smallIsLand-portcode"
											onChange={(e) => {
												field.onChange(e);
											}}
											{...field}
											checked={field.value}
											value={field.value}
										/>
									)}
								/>
								<Controller
									control={control}
									name="addPortCodeForm.isOmr"
									defaultValue={editPortCode?.isOmr || false}
									render={({ field }) => (
										<AbsCheckBox
											handleChange={(e) => {
												field.onChange(e.target.checked);
												handleisOmr(e);
											}}
											label={<span className="sm">EU OMR</span>}
											id="omr-portcode"
											onChange={(e) => {
												field.onChange(e);
											}}
											{...field}
											checked={field.value}
											value={field.value}
										/>
									)}
								/>
								<Controller
									control={control}
									name="addPortCodeForm.isTransnational"
									defaultValue={editPortCode?.isTransnational || false}
									render={({ field }) => (
										<AbsCheckBox
											handleChange={(e) => {
												field.onChange(e.target.checked);
												handleIsTransnational(e);
											}}
											label={<span className="sm">EU PSO/PSC</span>}
										 	id="transnational-portcode"
											onChange={(e) => {
												field.onChange(e);
											}}
											{...field}
											checked={field.value}
											value={field.value}
										/>
									)}
								/>
							</div>
						
					</MDBCol>

					<MDBCol md="3" className="pl-0">
						<Controller
							control={control}
							name="addPortCodeForm.isFuelEuPort"
							defaultValue={editPortCode?.isFeuPort || false}
							render={({ field }) => (
								<AbsCheckBox
									handleChange={(e) => {
										field.onChange(e.target.checked);
										handleFuelEuPort(e);
									}}
									label={<span className="sm">FuelEU Port</span>}
									id="fuelEuPort-portcode"
									onChange={(e) => {
										field.onChange(e);
									}}
									{...field}
									checked={field.value}
									value={field.value}
								/>
							)}
						/>
						
							<div className="sub-checkbox-list">
								<Controller
									control={control}
									name="addPortCodeForm.isFuelTransShipment"
									defaultValue={editPortCode?.isFeuTransshipment || false}
									render={({ field }) => (
										<AbsCheckBox
											handleChange={(e) => {
												field.onChange(e.target.checked);
												handleFuelIsTransShipment(e);
											}}
											label={<span className="sm">FEU Transhipment</span>}
											id="fuel-TransShipment-portcode"
											onChange={(e) => {
												field.onChange(e);
											}}
											{...field}
											checked={field.value}
											value={field.value}
										/>
									)}
								/>
								<Controller
									control={control}
									name="addPortCodeForm.isFuelSmallIsland"
									defaultValue={editPortCode?.isFeuSmallIsland || false}
									render={({ field }) => (
										<AbsCheckBox
											handleChange={(e) => {
												field.onChange(e.target.checked);
												handleFuelIsSmallIsLand(e);
											}}
											label={<span className="sm">FEU Small Island</span>}
											id="fuel-smallIsLand-portcode"
											onChange={(e) => {
												field.onChange(e);
											}}
											{...field}
											checked={field.value}
											value={field.value}
										/>
									)}
								/>
								<Controller
									control={control}
									name="addPortCodeForm.isFuelOmr21"
									defaultValue={editPortCode?.isFeuOmr21 || false}
									render={({ field }) => (
										<AbsCheckBox
											handleChange={(e) => {
												field.onChange(e.target.checked);
												handleFuelIsOmr21(e);
											}}
											label={<span className="sm">FEU OMR21</span>}
											id="fuel-omr21-portcode"
											onChange={(e) => {
												field.onChange(e);
											}}
											{...field}
											checked={field.value}
											value={field.value}
										/>
									)}
								/>
								<Controller
									control={control}
									name="addPortCodeForm.isFuelOmr24"
									defaultValue={editPortCode?.isFeuOmr24 || false}
									render={({ field }) => (
										<AbsCheckBox
											handleChange={(e) => {
												field.onChange(e.target.checked);
												handleFuelIsOmr24(e);
											}}
											label={<span className="sm">FEU OMR24</span>}
											id="fuel-omr24-portcode"
											onChange={(e) => {
												field.onChange(e);
											}}
											{...field}
											checked={field.value}
											value={field.value}
										/>
									)}
								/>
								<Controller
									control={control}
									name="addPortCodeForm.isFuelTransnational25"
									defaultValue={editPortCode?.isFeuTransnational25 || false}
									render={({ field }) => (
										<AbsCheckBox
											handleChange={(e) => {
												field.onChange(e.target.checked);
												handleFuelIsTransnational25(e);
											}}
											label={<span className="sm">FEU PSO/PSC25</span>}
											id="fuel-transnational25-portcode"
											onChange={(e) => {
												field.onChange(e);
											}}
											{...field}
											checked={field.value}
											value={field.value}
										/>
									)}
								/>
								<Controller
									control={control}
									name="addPortCodeForm.isFuelTransnational26"
									defaultValue={editPortCode?.isFeuTransnational26 || false}
									render={({ field }) => (
										<AbsCheckBox
											handleChange={(e) => {
												field.onChange(e.target.checked);
												handleFuelIsTransnational26(e);
											}}
											label={<span className="sm">FEU PSO/PSC26</span>}
											id="fuel-transnational26-portcode"
											onChange={(e) => {
												field.onChange(e);
											}}
											{...field}
											checked={field.value}
											value={field.value}
										/>
									)}
								/>
							</div>
						
					</MDBCol>

					<MDBCol md="3" className="pl-0">
						<Controller
							control={control}
							name="addPortCodeForm.isUkPort"
							defaultValue={editPortCode?.isUkPort || false}
							render={({ field }) => (
								<AbsCheckBox
									handleChange={(e) => {
										field.onChange(e.target.checked);
										handleUkPort(e);
									}}
									label="UK Port"
									id="ukPort-portcode"
									onChange={(e) => {
										field.onChange(e);
									}}
									{...field}
									checked={field.value}
									value={field.value}
								/>
							)}
						/>
					</MDBCol>

					<MDBCol md="3" className="pl-0">
						<Controller
							control={control}
							name="addPortCodeForm.isTerritory"
							defaultValue={editPortCode?.isTerritory || false}
							render={({ field }) => (
								<AbsCheckBox
									handleChange={handleTerritoryChange}
									label="Territory"
									id="territory-portcode-parent"
									checked={field.value}
									value={field.value}
								/>
							)}
						/>
					</MDBCol>
					
					<MDBCol md="3" className="input-div-height mt-4">
						<Controller
									name="addPortCodeForm.thetis"
								 control={control}
									rules={{
										maxLength: {
											value: 2,
											message: "Max length is 2 characters",
										},
										minLength: {
											value: 2,
											message: "Min length is 2 characters",
										},
									}}
									defaultValue={editPortCode?.thetis || ""}
									render={({ field }) => (
										<Input
											{...field}
											id="thetis-input-portcode"
											onChange={(e) => {
												field.onChange(e);
											}}
											className="inputHeight"
											type="text"
											label="THETIS Country Code"
											bold
											value={field.value}
											autoFocus={false}
										/>
									)}
								/>
								<div className="mt-1">
									{errors?.addPortCodeForm?.thetis && (
											<div className="error">
												{
													errors.addPortCodeForm
														.thetis.message
												}
											</div>
										)}
								</div>
					</MDBCol>
				</MDBRow>

				<MDBRow className="checkbox-row pl-0">
					{isTerritory && (
						<MDBCol md="12">
							<MDBCol
								md="12"
								className="pt-4 input-div-height pl-1 pr-0"
							>
								<Controller
									name="addPortCodeForm.territory"
								 control={control}
									rules={{
										required: isTerritory
											? "Territory Name is required"
											: false,
										validate: (value) =>
											!!value.trim() ||
											"Territory Name is required",
									}}
									defaultValue={editPortCode?.territory || ""}
									render={({ field }) => (
										<Input
											{...field}
											required
											id="territory-input-portcode"
											onChange={(e) => {
												field.onChange(e);
											}}
											className="inputHeight"
											type="text"
											label="Territory Name"
											bold
											value={field.value}
											autoFocus={false}
										/>
									)}
								/>
								<div className="mt-1">
									{isTerritory &&
										errors?.addPortCodeForm?.territory && (
											<div className="error">
												{
													errors.addPortCodeForm
														.territory.message
												}
											</div>
										)}
								</div>
							</MDBCol>
						</MDBCol>
					)}
				</MDBRow>

				<div className="d-flex justify-content-end mt-5 mr-3">
					<button
						type="submit"
						className="mr-3  save-button"
						id="save-update-btn-portcode"
					>
						{!editPortCode ? "Save" : "Update"}
					</button>
					<button
						id="cancel-btn-portcode"
						type="button"
						className="clear-button"
						onClick={handleCancel}
					>
						Cancel
					</button>
				</div>
			</form>
		</>
	);
};
export default AddPortCode;
